import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ConnectedSegmentDate } from '../Segment/SegmentDate';
import { DatePicker } from '../../../components/DatePicker';
import { useSegmentContext } from '../Segment/SegmentManager/Context';
import { CalendarType, CalendarTypeProp, DateType } from '../../../models';
import * as TrackingUtilsModule from '../../../utils/TrackingUtils';

const TrackingUtils = TrackingUtilsModule.TrackingUtils;

const CALENDAR_TO_DATE_TYPE = {
    [CalendarType.DEPARTURE]: DateType.FROM,
    [CalendarType.RETURN]: DateType.UNTIL,
};

export const DateDesktop = ({
    open,
    onChangeFocus,
    placeholderKey,
    isDatesRangeShown,
    roundedCorners,
    type,
}) => {
    const { t } = useTranslation();
    const { segment } = useSegmentContext();
    const { id } = segment;

    const activeProduct = useSelector((state) => state.activeProduct?.activeProduct);

    const dateType = React.useMemo(
        () => CALENDAR_TO_DATE_TYPE[type],
        [type]
    );

    return (
        <ConnectedSegmentDate segmentId={id}>
            {({ error, dates, minDate, maxDate, setValue, value }) => (
                <DatePicker
                    value={value}
                    onSelect={setValue}
                    dates={dates}
                    isDatesRangeShown={isDatesRangeShown}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder={t(placeholderKey)}
                    validationError={error}
                    open={open}
                    onChangeFocus={onChangeFocus}
                    roundedCornersLast={roundedCorners}
                    type={type}
                    dateType={dateType}
                    trackEvent={TrackingUtils?.trackEvent}
                    activeProduct={activeProduct}
                />
            )}
        </ConnectedSegmentDate>
    );
};

DateDesktop.propTypes = {
    isDatesRangeShown: PropTypes.bool,
    onChangeFocus: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    placeholderKey: PropTypes.string.isRequired,
    roundedCorners: PropTypes.bool,
    type: CalendarTypeProp,
};

DateDesktop.defaultProps = {
    isDatesRangeShown: false,
    roundedCorners: false,
    type: CalendarType.DEPARTURE,
};
